import { Box } from "@mui/material";
import { useState } from "react";
import DotLegalAutocomplete, { AutocompleteOption } from "../../common/autocomplete/DotLegalAutocomplete";
import { Organization, PriceDisclaimerType } from "./Organization.types";
import { mapPriceDisclaimer } from "./OrganizationTable.hooks";

export interface IConfigureOrganizationWatchPriceDisclaimer {
    organization: Organization;
    onOrganizationChanged: (organization: Organization) => void;
}

export default function ConfigureOrganizationWatchPriceDisclaimer(props: IConfigureOrganizationWatchPriceDisclaimer) {
    const disclaimerOptions: AutocompleteOption<PriceDisclaimerType>[] = [];

    for (const disclaimer in PriceDisclaimerType) {
        // Filter out the enum's numeric keys to avoid calling the function multiple times for each enum value
        if (isNaN(Number(disclaimer))) {
            if (!disclaimerOptions.some((x) => x.value?.toString() === disclaimer)) {
                const disclaimerEnum = PriceDisclaimerType[disclaimer as keyof typeof PriceDisclaimerType];
                disclaimerOptions.push({ label: mapPriceDisclaimer(disclaimerEnum), value: disclaimerEnum });
            }
        }
    }

    const [selectedPriceDisclaimer, setSelectedPriceDisclaimer] = useState<AutocompleteOption<PriceDisclaimerType>>(
        disclaimerOptions.find((options) => options.value === props.organization.watchPriceDisclaimer)!
    );

    const onPriceDisclaimerChange = (newValue: AutocompleteOption<PriceDisclaimerType>[]) => {
        setSelectedPriceDisclaimer(newValue[0] ?? { label: "Fee excluded", value: 1 });
        props.onOrganizationChanged({
            ...props.organization,
            watchPriceDisclaimer: newValue[0]?.value ?? 1,
        });
    };

    return (
        <Box sx={(theme) => ({ display: "flex", width: "100%", flexDirection: "column", gap: theme.spacing(5.5), alignItems: "center" })}>
            <Box id="singleSelectDropdown" sx={{ width: 270 }}>
                <DotLegalAutocomplete
                    onChange={onPriceDisclaimerChange}
                    label="Email Price Disclaimer Watches"
                    options={disclaimerOptions}
                    singleSelect
                    // @ts-ignore
                    value={selectedPriceDisclaimer}
                    width={"100%"}
                    tooltip={
                        <>
                            The email price disclaimer is linked to the renewal reminder sent to renewal contacts. It determines whether a specific disclaimer
                            paragraph is included in the watch reminder email.
                            <br />
                            <br />
                            Bech-Bruun fee excluded:&nbsp;
                            <Box component={"span"} sx={{ fontStyle: "italic" }}>
                                Bech-Bruun fee excluded: Please note that the price estimates include database costs, but they are exclusive of Bech-Bruun’s
                                fees and VAT.
                            </Box>
                            <br />
                            <br />
                            Bech-Bruun fee included:&nbsp;
                            <Box component={"span"} sx={{ fontStyle: "italic" }}>
                                Bech-Bruun fee included: Please note that the price estimates include database costs as well as Bech-Bruun’s fees, but they are
                                exclusive of VAT.
                            </Box>
                            <br />
                            <br />
                            By default Bech-Bruun fee is excluded.
                            <br />
                            <br />
                            If “No disclaimer” is chosen neither of the paragraphs will be shown in the emails.
                        </>
                    }
                />
            </Box>
        </Box>
    );
}
